// src/components/Explore/ExploreGrid.jsx
// Literal markup match of the reference's .a-explore-grid/.a-explore-card/
// .a-explore-mark/.go. Rendered inside HomeTemplate's
// <section class="a-section a-section--explore" id="explore">. Static by
// design — these four cards are site navigation (matching the real nav
// taxonomy: It Guhso = /blog, per Navbar.js), not data-driven content, so
// they're not wired to the `categories` table (which is a different,
// unreconciled taxonomy).
import React from 'react';
import { Link } from 'react-router-dom';
import './ExploreGrid.css';

const SECTIONS = [
  {
    mark: 'IG',
    title: 'It Guhso',
    description: 'The flagship show — conversations on self-sufficiency, culture, and the people building it.',
    cta: 'Read the blog →',
    href: '/blog',
  },
  {
    mark: 'TC',
    title: 'Tech',
    description: 'Reviews, breakdowns, and hot takes from the tech corner of Guhso.',
    cta: 'Read the blog →',
    href: '/tech',
  },
  {
    mark: 'MR',
    title: 'Merch',
    description: 'Hoodies, mugs, and gear from the Guhso store.',
    cta: 'Shop now →',
    href: '/merch',
  },
  {
    mark: 'DR',
    title: 'Directory',
    description: 'Sponsors and local businesses supporting the show.',
    cta: 'Browse directory →',
    href: '/directory',
  },
];

const ExploreGrid = () => (
  <>
    <div className="a-rail-label">
      <h3>Explore Guhso</h3>
    </div>
    <div className="a-explore-grid">
      {SECTIONS.map((section) => (
        <Link className="a-explore-card" to={section.href} key={section.title}>
          <span className="a-explore-mark">{section.mark}</span>
          <h4>{section.title}</h4>
          <p>{section.description}</p>
          <span className="go">{section.cta}</span>
        </Link>
      ))}
    </div>
  </>
);

export default ExploreGrid;
